module.exports = __webpack_public_path__ + "static/images/lottery-piece.de2e108.png";